"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["FREELANCE"] = "FREELANCE";
    USER_TYPE["COMPANY"] = "COMPANY";
})(USER_TYPE = exports.USER_TYPE || (exports.USER_TYPE = {}));
